import AdUnit, { AdUnitFilter } from "@/models/adUnit";
import { AvailabilityFilterModel } from "@/models/availability";
import { Meta, QueryParams } from "@/models/general";

import api from "@/plugins/axios";

const AdUnitsAPI = {
  async new(payload: AdUnit): Promise<AdUnit | undefined> {
    return api.post("/ad_units", payload);
  },
  async list(params: QueryParams): Promise<{ data: AdUnit[]; meta?: Meta }> {
    return api.get("/ad_units", {
      params: params,
    });
  },
  async delete(id: string): Promise<void> {
    return api.delete(`/ad_units/${id}`);
  },
  async get(id: string): Promise<AdUnit> {
    return api.get(`/ad_units/${id}`);
  },
  async update(payload: AdUnit): Promise<AdUnit> {
    return api.put(`/ad_units/${payload.id}`, payload);
  },
};

export default AdUnitsAPI;
